import { ButtonBase, ButtonBaseProps } from '@rhg/libs/material';
import { PropsWithChildren } from 'react';

interface WrapperProps extends ButtonBaseProps {
    isEntirelyClickable: boolean;
    href?: string;
    component?: React.ElementType;
}

/**
 * A wrapper component that renders either its children directly or its children inside a ButtonBase component.
 * To be used when we want to make a whole element clickable conditionally
 * (e.g. when we have a button inside a card on desktop, but we want the whole card to be clickable on mobile).
 */
const ClickableWrapper = ({
    children,
    isEntirelyClickable,
    ...buttonProps
}: PropsWithChildren<WrapperProps>) => {
    if (isEntirelyClickable) {
        return <ButtonBase {...buttonProps}>{children}</ButtonBase>;
    }

    return <>{children}</>;
};

export default ClickableWrapper;
